import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { PresentationView, getPresentationOptions } from '@/module/Author/Presentation';

export const Route = createFileRoute('/_auth/author/_author/presentation/_presentation/$presentationId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { presentationId } = Route.useParams();
  const { data: presentation } = useSuspenseQuery(getPresentationOptions(presentationId));

  return <PresentationView presentation={presentation} />;
}
